import { action } from 'typesafe-actions';
import { ErrorCustominization, GiroWebappError } from '../../../model/error';
import { ApplicationErrorActionTypes } from './types';

export const markError = (error: GiroWebappError) => action(ApplicationErrorActionTypes.MARK_ERROR, error);
export const customizeErrorHandling = (record: ErrorCustominization) => action(ApplicationErrorActionTypes.CUSTOMIZE_HANDLING, record);
export const resolveError = (error: string) => action(ApplicationErrorActionTypes.RESOLVE_ERROR, error);
export const reset = () => action(ApplicationErrorActionTypes.RESET);
